const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)
import employeesRoutes from '@/modules/employees/routes'
import positionsRoutes from '@/modules/positions/routes'

export default [
  {
    path: '/schedule',
    name: 'Schedule',
    component: _import('schedule/components/wrapper'),
    redirect: '/schedule',
    meta: {
      showInMenu: true,
      title: 'График и сотрудники',
      menuKey: 'schedule',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    children: [
      {
        path: '',
        name: 'Schedule.main',
        component: _import('schedule/components/schedule'),
        meta: {
          menuKey: 'schedule',
          title: 'График работы',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      ...positionsRoutes,
      ...employeesRoutes,
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/schedule/routes.js